// @ts-nocheck


import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';

import notification from 'antd/lib/notification';


import { accessTypeEnum } from '../../lib/enum';

import { Panel } from './../../components/layout';
import Header from '../../components/layout/Header';
import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import { notificationLoading } from './../../components/Notifications';
import { Tabs, TabItem } from './../../components/ui';


import {
  cleanVehicleModel,
  fetchVehicleModel,
  updateVehicleModel,
  addVehicleModel } from
'../../ducks/vehicleModel';

import InnerForm from './components/InnerForm';
import InnerCard from './components/InnerCard';
import VehicleModelMaintenance from './VehicleModelMaintenance';
import { RouteComponent } from '../../lib/routerAdapter';

const StyledPanel = styled(Panel)`
  padding-top: 0;
`;
















class VehicleModelForm extends Component {
  state = {
    activeTab: 'main'
  };

  async componentDidMount() {
    const { vehicleModelId } = this.props;
    await this.props.cleanVehicleModel();
    if (vehicleModelId) {
      try {
        await this.props.fetchVehicleModel(this.props.vehicleModelId);
      } catch (error) {
        navigate('/vehicle-models');
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
      }
    }
  }

  handleSubmit = async (values) => {
    const { model, updateVehicleModel, addVehicleModel } = this.props;
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      if (model) {
        await updateVehicleModel({
          ...values,
          id: model.id
        });
      } else {
        await addVehicleModel(values);
      }
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      navigate('/vehicle-models');
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  canAdd = () =>
  this.props.userAccess.some((access) =>
  [
  accessTypeEnum.admin,
  accessTypeEnum.adminBranch,
  accessTypeEnum.handlingBrandsAndVehicleModels].
  includes(access)
  );

  render() {
    const { model, vehicleModelId } = this.props;
    const mainTab = this.canAdd() ?
    <RouteComponent
      component={InnerForm}
      vehicleModel={model}
      onSubmit={this.handleSubmit}
      onCancel={() => navigate('/vehicle-models')} /> :

    <RouteComponent component={InnerCard} vehicleModel={model} />;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/vehicle-models">Модели ТС</Crumb>
              {model ?
            <Crumb to={`/vehicle-models/${model.id}`}>
                  Модель ТС №{model.id}
                </Crumb> :

            <Crumb to="/vehicle-models/new">Новая модель ТС</Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>{model ? `Модель ТС №${model.id}` : 'Новая модель ТС'}</h1>
        </StyledPanel>
        {model &&
        <Tabs withRouter>
            <TabItem
            url={`/vehicle-models/${model.id}/form`}
            activeUrl={[
            `/vehicle-models/${model.id}`,
            `/vehicle-models/${model.id}/form`]
            }
            tabKey="main"
            label="Данные модели" />

            <TabItem
            url={`/vehicle-models/${model.id}/maintenance`}
            tabKey="maintenance"
            label="Техническое обслуживание" />

          </Tabs>
        }
        <Routes>
          <Route index element={mainTab} />
          <Route path="form" element={mainTab} />

          {!!vehicleModelId &&
          <Route
            path="maintenance"
            element={
            <RouteComponent
              component={VehicleModelMaintenance}
              vehicleModelId={vehicleModelId} />

            } />

          }
        </Routes>
      </>);

  }
}

export default connect(
  (state, ownProps) => ({
    userAccess: state.auth.profile.access,
    model: state.vehicleModel,
    vehicleModelId: parseInt(ownProps.vehicleModelId, 10)
  }),
  {
    fetchVehicleModel,
    cleanVehicleModel,
    updateVehicleModel,
    addVehicleModel
  }
)(VehicleModelForm);
